import * as preact from "preact";

import Dialog from "views/Dialog";

export default function SocialShareDialog() {
  return (
    <Dialog heading="Spread the word" headingIcon="thumbs-up-alt">
      <img
        class="myProfilePic noMobile"
        src="/content/internationalLabPhotoSml.jpg"
      />

      <p>
        Please share <a href="https://readlang.com">readlang.com</a> on
        Instagram, Facebook, or your favorite social media site, or simply
        mention it to a friend.
      </p>

      <p>
        My goal is to make it the best reading tool in the world for language
        learners!
      </p>

      <p>
        Thanks,
        <br />
        Steve
      </p>
    </Dialog>
  );
}
